var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.566 6.70493C26.3848 3.89523 24.9348 1.74955 24.3622 0.882324C23.7872 1.74955 22.3372 3.89523 21.1572 6.70493C22.3132 7.95799 23.4535 9.43239 24.3622 11.1064C25.2685 9.43239 26.4124 7.95799 27.566 6.70493Z",
    fill: "#009900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1572 43.3038C22.336 46.1135 23.7872 48.2567 24.3622 49.1251C24.9348 48.2567 26.386 46.1147 27.566 43.3038C26.4124 42.0507 25.2685 40.5739 24.3622 38.9011C23.4535 40.5751 22.3132 42.0507 21.1572 43.3038Z",
    fill: "#009900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1576 6.70496C19.1002 4.46857 17.0079 2.95546 16.1749 2.3374C15.9288 3.34856 15.2962 5.86435 15.1426 8.91232C16.6502 9.69125 18.2251 10.6855 19.6451 11.9409C19.9308 10.0565 20.4998 8.27733 21.1576 6.70496Z",
    fill: "#009900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5664 43.3036C29.6226 45.54 31.7161 47.0531 32.5503 47.6687C32.794 46.6576 33.4302 44.143 33.5814 41.0974C32.0738 40.3185 30.4989 39.3207 29.0801 38.0652C28.7956 39.9496 28.223 41.7288 27.5664 43.3036Z",
    fill: "#009900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1428 8.91223C12.448 7.5225 9.96806 6.81977 8.97656 6.52344C9.0882 7.56241 9.34507 10.1447 10.2369 13.0609C11.9187 13.2701 13.7348 13.662 15.4969 14.3563C15.1236 12.4876 15.0552 10.6164 15.1428 8.91223Z",
    fill: "#009900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5809 41.0976C36.2757 42.4861 38.7545 43.1888 39.7484 43.4815C39.6367 42.4462 39.3775 39.8626 38.4856 36.9477C36.8039 36.7373 34.9901 36.3417 33.2256 35.6499C33.5989 37.5234 33.6685 39.3897 33.5809 41.0976Z",
    fill: "#009900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4163 18.055C11.4332 16.4258 10.7358 14.6902 10.2365 13.0609C7.23195 12.6811 4.66437 12.8759 3.63086 12.9436C4.0882 13.8762 5.20694 16.2141 7.03029 18.6489C8.6844 18.2667 10.5258 18.0127 12.4163 18.055Z",
    fill: "#009900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3066 31.9523C37.2909 33.5827 37.9932 35.3171 38.4865 36.9488C41.4934 37.3261 44.061 37.1326 45.0945 37.0685C44.636 36.1299 43.5184 33.7919 41.6915 31.3572C40.0398 31.7394 38.2008 31.9958 36.3066 31.9523Z",
    fill: "#009900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03021 18.6489C4.08091 19.3287 1.7342 20.3943 0.787109 20.8164C1.53494 21.5348 3.3799 23.3467 5.92107 25.0049C7.3423 24.0797 8.9844 23.2003 10.7789 22.5919C9.3001 21.3982 8.05532 20.0072 7.03021 18.6489Z",
    fill: "#009900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.803 25.0037C41.3805 25.9326 39.7384 26.8083 37.9463 27.4179C39.4227 28.6092 40.6699 29.9966 41.6926 31.3561C44.6443 30.6775 46.991 29.6119 47.9393 29.1922C47.1903 28.4738 45.3453 26.6583 42.803 25.0037Z",
    fill: "#009900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.778 27.4179C8.98342 26.8083 7.34133 25.9314 5.92009 25.0037C3.37892 26.6583 1.53396 28.4738 0.786133 29.1934C1.73322 29.6131 4.07993 30.6787 7.02923 31.3573C8.05554 29.9978 9.30032 28.6092 10.778 27.4179Z",
    fill: "#009900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9463 22.5895C39.7384 23.1979 41.3805 24.0772 42.803 25.0025C45.3453 23.3454 47.1915 21.5324 47.9393 20.8139C46.991 20.393 44.6455 19.3262 41.6926 18.6465C40.6687 20.0072 39.4227 21.3981 37.9463 22.5895Z",
    fill: "#009900"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03029 31.3572C5.20694 33.7919 4.0882 36.1299 3.63086 37.0685C4.66437 37.1338 7.23195 37.3261 10.2365 36.9488C10.7358 35.3171 11.4332 33.5827 12.4163 31.9523C10.5258 31.9958 8.6844 31.7394 7.03029 31.3572Z",
    fill: "#009900"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6925 18.649C43.5182 16.2155 44.637 13.8775 45.0955 12.9401C44.062 12.876 41.4944 12.6813 38.4875 13.061C37.9929 14.6903 37.2919 16.4259 36.3076 18.0551C38.2006 18.0128 40.0396 18.2668 41.6925 18.649Z",
    fill: "#009900"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.495 35.6511C13.7329 36.343 11.9167 36.7373 10.235 36.9489C9.34312 39.8639 9.08624 42.4474 8.97461 43.4827C9.96611 43.19 12.4461 42.4873 15.1409 41.0988C15.0545 39.3897 15.1229 37.5235 15.495 35.6511Z",
    fill: "#009900"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2275 14.3563C34.9921 13.6608 36.8058 13.2701 38.4876 13.0609C39.3794 10.1435 39.6387 7.5612 39.7503 6.52344C38.7564 6.81735 36.2777 7.52008 33.5828 8.90981C33.6693 10.6164 33.5997 12.4839 33.2275 14.3563Z",
    fill: "#009900"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1426 41.0974C15.295 44.143 15.9288 46.6576 16.1749 47.6687C17.0079 47.0531 19.1002 45.54 21.1576 43.3036C20.4998 41.7288 19.9296 39.9484 19.6451 38.0652C18.2251 39.3207 16.6502 40.3197 15.1426 41.0974Z",
    fill: "#009900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5814 8.90869C33.4302 5.86314 32.794 3.34735 32.5503 2.3374C31.7161 2.95425 29.6226 4.46736 27.5664 6.70496C28.223 8.27491 28.7944 10.0565 29.0801 11.9409C30.4989 10.6855 32.075 9.69004 33.5814 8.90869Z",
    fill: "#009900"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7211 15.6262C23.0236 13.9958 23.6129 12.4839 24.362 11.105C23.4533 9.43228 22.3141 7.95788 21.157 6.70361C20.4992 8.27719 19.929 10.0552 19.6445 11.9396C20.8173 12.9822 21.8856 14.199 22.7211 15.6262Z",
    fill: "#99CC00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0032 34.3796C25.6983 36.0113 25.1125 37.5232 24.3623 38.9008C25.2686 40.5736 26.4125 42.0492 27.5661 43.3034C28.2227 41.7286 28.7941 39.9482 29.0797 38.065C27.907 37.0248 26.8375 35.8081 26.0032 34.3796Z",
    fill: "#99CC00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4955 14.3561C16.9479 14.9282 18.3643 15.7035 19.6367 16.7546C19.3678 15.1205 19.4087 13.4962 19.6451 11.9395C18.2251 10.684 16.6502 9.69103 15.1426 8.91089C15.0549 10.6163 15.1233 12.4874 15.4955 14.3561Z",
    fill: "#99CC00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2273 35.6509C31.7749 35.08 30.3609 34.3011 29.0897 33.2512C29.3574 34.8865 29.3153 36.5084 29.0801 38.0663C30.4989 39.3218 32.075 40.3196 33.5815 41.0985C33.6691 39.3895 33.5995 37.5232 33.2273 35.6509Z",
    fill: "#99CC00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1242 18.8822C16.314 17.4392 15.8038 15.8983 15.4954 14.3562C13.7332 13.6619 11.9171 13.27 10.2354 13.0608C10.7347 14.69 11.4321 16.4257 12.4152 18.0549C13.9745 18.09 15.5722 18.3331 17.1242 18.8822Z",
    fill: "#99CC00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6016 31.1238C32.4082 32.5679 32.9208 34.1064 33.2269 35.6498C34.9914 36.3416 36.8051 36.7371 38.4869 36.9476C37.9923 35.3159 37.2913 33.5815 36.307 31.9511C34.7465 31.9172 33.1524 31.6753 31.6016 31.1238Z",
    fill: "#99CC00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7778 22.5894C12.2543 22.085 13.8363 21.7633 15.482 21.7451C14.2325 20.6675 13.2254 19.3975 12.4163 18.0549C10.5257 18.0114 8.68438 18.2654 7.03027 18.6476C8.05538 20.0071 9.30016 21.398 10.7778 22.5894Z",
    fill: "#99CC00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9454 27.4177C36.4678 27.9197 34.8869 28.2414 33.2412 28.2595C34.4908 29.3384 35.4967 30.6108 36.3057 31.9522C38.1999 31.9957 40.0389 31.7393 41.6918 31.3571C40.6679 29.9964 39.4219 28.6091 37.9454 27.4177Z",
    fill: "#99CC00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9107 25.0036C13.3718 24.4218 11.9962 23.5715 10.7778 22.5906C8.98325 23.199 7.34115 24.0783 5.91992 25.0036C7.34115 25.9325 8.98325 26.8082 10.7778 27.4178C11.9962 26.4332 13.3718 25.5853 14.9107 25.0036Z",
    fill: "#99CC00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8115 25.0036C35.354 25.5865 36.7272 26.4332 37.9456 27.4178C39.7377 26.8082 41.3798 25.9313 42.8023 25.0036C41.3798 24.0783 39.7377 23.199 37.9456 22.5906C36.7272 23.5715 35.3528 24.4218 33.8115 25.0036Z",
    fill: "#99CC00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4163 31.9522C13.2254 30.6108 14.2325 29.3396 15.482 28.2595C13.8363 28.2414 12.2543 27.9221 10.7778 27.4177C9.30016 28.6091 8.05538 29.9976 7.03027 31.3559C8.68438 31.7393 10.5257 31.9957 12.4163 31.9522Z",
    fill: "#99CC00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3057 18.0549C35.4967 19.3987 34.4908 20.6674 33.2412 21.7451C34.8869 21.762 36.4678 22.085 37.9454 22.5894C39.4219 21.398 40.6691 20.007 41.6918 18.6476C40.0389 18.2666 38.1999 18.0126 36.3057 18.0549Z",
    fill: "#99CC00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.124 31.1238C15.572 31.6753 13.9743 31.916 12.4162 31.9511C11.4331 33.5815 10.7357 35.3159 10.2363 36.9476C11.918 36.7359 13.7342 36.3416 15.4963 35.6498C15.8036 34.1076 16.3138 32.5691 17.124 31.1238Z",
    fill: "#99CC00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6016 18.8822C33.1524 18.3331 34.7465 18.09 36.3058 18.0549C37.2901 16.4257 37.9923 14.69 38.4857 13.0608C36.8039 13.27 34.9902 13.6607 33.2257 14.3562C32.922 15.8995 32.4082 17.4392 31.6016 18.8822Z",
    fill: "#99CC00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7211 34.3796C21.8856 35.8069 20.8173 37.0248 19.6445 38.065C19.9302 39.9482 20.5004 41.7286 21.157 43.3034C22.3129 42.0504 23.4533 40.5736 24.362 38.9008C23.6117 37.5232 23.0236 36.0113 22.7211 34.3796Z",
    fill: "#99CC00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6367 33.25C18.3655 34.3011 16.9491 35.0788 15.4955 35.6497C15.1233 37.522 15.0549 39.3895 15.1426 41.0973C16.6502 40.3184 18.2251 39.3205 19.6451 38.0651C19.4087 36.5072 19.3678 34.884 19.6367 33.25Z",
    fill: "#99CC00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0032 15.6262C26.8375 14.199 27.907 12.9798 29.0797 11.9396C28.7953 10.0552 28.2227 8.27356 27.5661 6.70361C26.4125 7.95667 25.2686 9.43107 24.3623 11.105C25.1125 12.4839 25.6983 13.9958 26.0032 15.6262Z",
    fill: "#99CC00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0895 16.7558C30.3606 15.7047 31.7747 14.9294 33.2271 14.3573C33.6004 12.485 33.6701 10.6163 33.5824 8.90967C32.0748 9.68981 30.4999 10.6852 29.0811 11.9407C29.3151 13.4974 29.3571 15.1217 29.0895 16.7558Z",
    fill: "#99CC00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7277 20.4812C21.8838 18.9633 20.8239 17.7392 19.6367 16.7559C19.8876 18.2847 20.4098 19.8196 21.2909 21.3158C19.9825 20.1812 18.5732 19.3963 17.1244 18.8822C17.8746 20.2296 18.8877 21.4948 20.2273 22.5966C18.6092 21.9798 17.0176 21.7282 15.4835 21.7463C16.649 22.7551 18.0259 23.5897 19.6584 24.1678C17.931 24.1448 16.3513 24.4581 14.9121 25.0024C16.3513 25.5466 17.931 25.8599 19.6584 25.8381C18.0271 26.4139 16.649 27.2521 15.4835 28.2584C17.0176 28.2753 18.6092 28.0261 20.2273 27.4093C18.8889 28.51 17.8746 29.7727 17.1244 31.1225C18.5732 30.6097 19.9825 29.8223 21.2909 28.689C20.4098 30.1851 19.8876 31.72 19.6367 33.2488C20.8239 32.2655 21.8838 31.0427 22.7277 29.5272C22.4072 31.235 22.4408 32.8582 22.7217 34.3785C23.5043 33.0444 24.0817 31.5313 24.3626 29.8162C24.6435 31.5313 25.2208 33.0444 26.0035 34.3785C26.2868 32.8582 26.3156 31.235 25.9963 29.5272C26.8401 31.0427 27.8989 32.2655 29.0884 33.2488C28.8375 31.72 28.313 30.1851 27.4307 28.689C28.7415 29.8223 30.1519 30.6097 31.602 31.1225C30.847 29.7727 29.8351 28.5112 28.499 27.4093C30.1159 28.0261 31.7052 28.2753 33.2417 28.2584C32.0749 27.2508 30.6957 26.4139 29.0668 25.8357C30.7917 25.8599 32.3726 25.5466 33.8107 25.0024C32.3726 24.4581 30.7917 24.1448 29.0668 24.1678C30.6957 23.5897 32.0737 22.7551 33.2417 21.7463C31.7052 21.7294 30.1159 21.9798 28.4966 22.5966C29.8351 21.4948 30.847 20.2308 31.602 18.8822C30.1519 19.3987 28.7415 20.1812 27.4307 21.3158C28.3142 19.8184 28.8375 18.2823 29.0884 16.7547C27.8989 17.7392 26.8401 18.962 25.9963 20.48C26.3156 18.7685 26.2856 17.1454 26.0035 15.625C25.2196 16.9555 24.6435 18.471 24.3626 20.1885C24.0817 18.471 23.5043 16.9555 22.7217 15.625C22.4408 17.1466 22.4072 18.7697 22.7277 20.4812Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7284 20.4813C22.4079 18.7698 22.4415 17.1467 22.7224 15.6263C21.8869 14.1991 20.8186 12.9823 19.6458 11.9397C19.4094 13.4963 19.3698 15.1207 19.6374 16.7548C20.8246 17.7393 21.8845 18.9633 22.7284 20.4813Z",
    fill: "#FFE600"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.998 29.5286C26.3173 31.2364 26.2873 32.8596 26.0052 34.3799C26.8395 35.8072 27.909 37.0251 29.0818 38.0653C29.317 36.5075 29.3591 34.8855 29.0914 33.2502C27.9006 32.2669 26.8407 31.0441 25.998 29.5286Z",
    fill: "#FFE600"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6373 16.7561C18.3662 15.7051 16.9497 14.9298 15.4961 14.3577C15.8046 15.8998 16.3147 17.4407 17.125 18.8837C18.5738 19.3965 19.983 20.1827 21.2914 21.3172C20.4104 19.8198 19.8882 18.2838 19.6373 16.7561Z",
    fill: "#FFE600"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0896 33.2503C30.3608 34.3014 31.7748 35.0791 33.2272 35.65C32.9223 34.1066 32.4086 32.5681 31.6019 31.124C30.1519 30.6111 28.7415 29.8237 27.4307 28.6904C28.3141 30.1866 28.8387 31.7215 29.0896 33.2503Z",
    fill: "#FFE600"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2278 22.5969C18.8894 21.495 17.8751 20.2311 17.1248 18.8825C15.5728 18.3334 13.9751 18.0903 12.417 18.0552C13.226 19.3989 14.2331 20.6677 15.4827 21.7454C17.0168 21.7285 18.6097 21.98 20.2278 22.5969Z",
    fill: "#FFE600"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.499 27.4119C29.835 28.5125 30.8469 29.7753 31.602 31.1251C33.1528 31.6766 34.7469 31.9173 36.3062 31.9524C35.4972 30.611 34.4912 29.3398 33.2417 28.2597C31.7052 28.2767 30.1159 28.0287 28.499 27.4119Z",
    fill: "#FFE600"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6574 24.168C18.0261 23.5899 16.6481 22.7553 15.4825 21.7466C13.8368 21.7635 12.2548 22.0865 10.7783 22.5908C11.9967 23.573 13.3711 24.4232 14.9112 25.0038C16.3504 24.4595 17.9301 24.1451 19.6574 24.168Z",
    fill: "#FFE600"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0674 25.837C30.6963 26.4152 32.0743 27.2533 33.2423 28.2597C34.888 28.2415 36.4688 27.9198 37.9465 27.4178C36.7281 26.4333 35.3537 25.5854 33.8124 25.0037C32.3744 25.5479 30.7935 25.8612 29.0674 25.837Z",
    fill: "#FFE600"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9112 25.0037C13.3723 25.5866 11.9967 26.4333 10.7783 27.4178C12.2548 27.9222 13.8368 28.2415 15.4825 28.2597C16.6481 27.2521 18.0249 26.4152 19.6574 25.8394C17.9301 25.8612 16.3504 25.5479 14.9112 25.0037Z",
    fill: "#FFE600"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8124 25.0038C35.3549 24.422 36.7281 23.5717 37.9465 22.5908C36.4688 22.0865 34.888 21.7647 33.2423 21.7466C32.0755 22.7553 30.6963 23.5899 29.0674 24.168C30.7935 24.1451 32.3744 24.4595 33.8124 25.0038Z",
    fill: "#FFE600"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2275 27.4119C18.6095 28.0287 17.0178 28.2779 15.4837 28.2609C14.2341 29.3398 13.227 30.6122 12.418 31.9536C13.976 31.9185 15.5737 31.6766 17.1258 31.1263C17.8748 29.7753 18.8879 28.5125 20.2275 27.4119Z",
    fill: "#FFE600"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4971 22.5969C30.1164 21.9801 31.7056 21.7285 33.2421 21.7466C34.4917 20.6689 35.4976 19.399 36.3066 18.0564C34.7474 18.0915 33.1533 18.3346 31.6024 18.8837C30.8474 20.2311 29.8355 21.495 28.4971 22.5969Z",
    fill: "#FFE600"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7217 34.3799C23.0242 36.0116 23.6136 37.5234 24.3626 38.9011C25.1128 37.5234 25.6986 36.0116 26.0035 34.3799C25.2196 33.0458 24.6435 31.5327 24.3626 29.8176C24.0817 31.5339 23.5043 33.0458 22.7217 34.3799Z",
    fill: "#FFE600"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7279 29.5286C21.884 31.0441 20.8241 32.2669 19.6369 33.2502C19.368 34.8843 19.4089 36.5075 19.6453 38.0653C20.8181 37.0251 21.8864 35.8084 22.7219 34.3799C22.441 32.8596 22.4074 31.2376 22.7279 29.5286Z",
    fill: "#FFE600"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.125 31.124C16.3147 32.5681 15.8046 34.1066 15.4961 35.65C16.9485 35.0791 18.365 34.3002 19.6373 33.2503C19.8882 31.7215 20.4104 30.1866 21.2914 28.6904C19.983 29.8237 18.5738 30.6111 17.125 31.124Z",
    fill: "#FFE600"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0035 15.6264C25.6986 13.996 25.1128 12.4841 24.3626 11.1052C23.6124 12.4841 23.0242 13.996 22.7217 15.6264C23.5043 16.9569 24.0817 18.4724 24.3626 20.1899C24.6435 18.4736 25.2208 16.9569 26.0035 15.6264Z",
    fill: "#FFE600"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.998 20.4813C26.8419 18.9634 27.9006 17.7393 29.0902 16.756C29.3579 15.1219 29.3158 13.4976 29.0806 11.9409C27.9078 12.9799 26.8383 14.1991 26.004 15.6275C26.2873 17.1467 26.3161 18.7698 25.998 20.4813Z",
    fill: "#FFE600"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6027 18.8824C32.4093 17.4395 32.9219 15.8986 33.228 14.3564C31.7755 14.9285 30.3615 15.7038 29.0903 16.7549C28.8394 18.2837 28.3149 19.8186 27.4326 21.316C28.7422 20.1815 30.1526 19.3989 31.6027 18.8824Z",
    fill: "#FFE600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpLogo);
export default __webpack_public_path__ + "static/media/bp_logo.24235227ac8a9479ecb2dc34d9fbcf29.svg";
export { ForwardRef as ReactComponent };